import { Risk } from 'types/suncorpRisks';

import { CombinedApiResponse } from 'hooks/useFetchScriptVariables';

export type GTAG_EVENTS =
  | 'section_viewed'
  | 'link_clicks'
  | 'report_sections'
  | 'voice_id'
  | 'address_entered'
  | 'house_type_shown'
  | 'report_interaction'
  | 'file_download'
  | 'about_the_project'
  | 'preloader-loading'
  | 'preloader-loaded'
  | 'landing-page-loaded'
  | 'initialising-loading'
  | 'initialising-loaded'
  | 'with-splash-screen'
  | 'with-splash-screen-gio'
  | 'splash-screen-close'
  | 'address-not-supported';

const googleTag = (variant: GTAG_EVENTS, args?: any) =>
  window.gtag('event', variant, args);

export interface GoogleTagFetchedDataProps {
  combinedData: CombinedApiResponse;
  risks: Risk[];
  firstTip: string;
  secondTip: string;
}

export const googleTagFetchedData = (props: GoogleTagFetchedDataProps) => {
  const yearBuilt = props.combinedData.coreLogic.propertyAge?.yearBuilt;

  googleTag('address_entered', {
    state: props.combinedData.geodata?.addressComponents.state,
    region: props.combinedData.geodata?.addressComponents.city,
    postcode: props.combinedData.geodata?.addressComponents.postalCode,
    address: `${props.combinedData.geodata?.addressComponents.streetNumber} ${props.combinedData.geodata?.addressComponents.streetName}`,
  });

  googleTag('house_type_shown', {
    property_type: props.combinedData.coreLogic.coreAttributes?.propertyType,
    property_subtype:
      props.combinedData.coreLogic.coreAttributes?.propertySubType,
    property_subtype_short:
      props.combinedData.coreLogic.coreAttributes?.propertySubTypeShort,
    age: yearBuilt && new Date().getFullYear() - yearBuilt,
  });
};

export const trackReportInteraction = (
  section: string,
  tip: string,
  tipNumber?: number
) => {
  googleTag('report_interaction', {
    report_section: section,
    resilience_tip: tip,
    ...(tipNumber !== undefined && { resilience_tip_number: tipNumber }),
  });
};

export const trackFileDownload = (
  url: string,
  text: string,
  pseudoId: string
) => {
  googleTag('file_download', {
    link_url: url,
    link_text: text,
    pseudo_id: pseudoId,
  });
};

export const trackAboutProject = () => {
  googleTag('about_the_project');
};

export const trackPreloaderLoading = () => {
  googleTag('preloader-loading');
};

export const trackPreloaderLoaded = () => {
  googleTag('preloader-loaded');
};

export const trackLandingPageLoaded = () => {
  googleTag('landing-page-loaded');
};

export const trackInitialisingLoading = () => {
  googleTag('initialising-loading');
};

export const trackInitialisingLoaded = () => {
  googleTag('initialising-loaded');
};

export const trackAddressNotSupported = () => {
  googleTag('address-not-supported');
};

export default googleTag;
